import D2C_Instance from '../Instance'

class D2C_InstanceGCP extends D2C_Instance {
  static active = true
  static objectType = 'instanceType'
  static providerType = 'GCP'
  get _title() {
    return `${this.id}, ${this.memory}GB RAM, ${this.cores} vCPU`
  }
}

export default D2C_InstanceGCP
